import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import { BuyBoxFilterOptions } from '@/stores/useUserStoreTypes';

import { computed, onMounted } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListBuyBoxFilter',
  props: {
    buyBoxFilterOptions: null,
    additionalContexts: null,
    isTitleUpcoming: { type: Boolean },
    buyboxFilterType: null
  },
  emits: ["filterClicked"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: 'filterClicked',
		{
			value,
			nonInteraction,
		}: {
			value: BuyBoxFilterOptions;
			nonInteraction?: boolean;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	buyBoxFilterOptions: BuyBoxFilterOptions[];
	additionalContexts: SnowplowContext[];
	isTitleUpcoming: boolean;
	buyboxFilterType: BuyBoxFilterOptions;
};

const HiddenHorizontalScrollbar = () => import('@/components/HiddenHorizontalScrollbar.vue');

const { tc } = useI18n();

const { activeRoute } = storeToRefs(useRoutingStore());




const filterOptions = computed(() => {
	const options = [
		{
			label: tc('WEBAPP_ALL'),
			value: BuyBoxFilterOptions.ALL,
		},
		{
			label: tc('WEBAPP_SUBSCRIPTION'),
			value: BuyBoxFilterOptions.SUBSCRIPTION,
		},
		{
			label: tc('WEBAPP_FREE'),
			value: BuyBoxFilterOptions.FREE,
		},
		{
			label: tc('WEBAPP_FREE_TV'),
			value: BuyBoxFilterOptions.FAST_TV,
		},
		{
			label: tc('WEBAPP_RENT'),
			value: BuyBoxFilterOptions.RENT,
		},
		{
			label: tc('WEBAPP_BUY'),
			value: BuyBoxFilterOptions.BUY,
		},
		{
			label: tc('WEBAPP_CINEMA'),
			value: BuyBoxFilterOptions.CINEMA,
		},
		{
			label: tc('WEBAPP_DISC'),
			value: BuyBoxFilterOptions.PHYSICAL,
		},
	];

	return options.filter(option => {
		return (
			props.buyBoxFilterOptions.includes(option.value) ||
			[
				BuyBoxFilterOptions.ALL,
				props.isTitleUpcoming ? BuyBoxFilterOptions.SUBSCRIPTION : null,
				BuyBoxFilterOptions.FREE,
			].includes(option.value)
		);
	});
});

const handleFilterClick = (value: BuyBoxFilterOptions) => {
	emit('filterClicked', { value });
};

onMounted(() => {
	if (activeRoute.value?.query.monetization_types === 'free') {
		emit('filterClicked', { value: BuyBoxFilterOptions.FREE, nonInteraction: true });
		return;
	}

	if (!filterOptions.value.find(filterOption => filterOption.value === props.buyboxFilterType)) {
		emit('filterClicked', { value: BuyBoxFilterOptions.ALL, nonInteraction: true });
		return;
	}
});

return { __sfc: true,HiddenHorizontalScrollbar, tc, activeRoute, props, emit, filterOptions, handleFilterClick }
}

})